// extracted by mini-css-extract-plugin
export var global = "style-module--global--msiO6";